import { create } from "zustand";
import { persist } from "zustand/middleware";

const useGeneralStore = create(
  persist(
    (set) => ({
      deviceId: "",
      isDeviceUsedAsAutoPrintInvoice: false,
      isDeviceUsedAsAutoPrintKitchenSlip: false,
      setDeviceId: (newDeviceId) => {
        set({ deviceId: newDeviceId });
      },
      setIsDeviceUsedAsAutoPrintInvoice: (val) => {
        set({ isDeviceUsedAsAutoPrintInvoice: val });
      },
      setIsDeviceUsedAsAutoPrintKitchenSlip: (val) => {
        set({ isDeviceUsedAsAutoPrintKitchenSlip: val });
      },
    }),
    {
      name: "general-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useGeneralStore;
